/**
 * Bhrigu Trimsamsha D30 Color Configuration
 * Colors for 3 spiritual categories: YAMA, NIYAMA, BHAKTI
 */

import { SpiritualCategory } from '../components/common/AstrologyChart/DataSections/data/BhriguTrimsamshaTableData';

/**
 * Color configuration for 3 spiritual categories
 */
export const CATEGORY_COLORS: Record<SpiritualCategory, string> = {
  YAMA: '#dc2626',      // Red - Restraints (self-control)
  NIYAMA: '#3b82f6',    // Blue - Observances (practices)
  BHAKTI: '#9333ea'     // Purple - Devotion (surrender)
};

/**
 * Get color for spiritual category
 */
export function getCategoryColor(category: SpiritualCategory): string {
  return CATEGORY_COLORS[category] || CATEGORY_COLORS.YAMA;
}
